import React, { useEffect, useState } from "react"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import Select from "react-select"
//i18n
import { withTranslation } from "react-i18next"
//Import Date Picker
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import API from "../../api"
import { Button, Col, Form, Input, Label, Row } from "reactstrap"
import getDay from "date-fns/getDay"

const AddRattrapage = props => {
  const [date, setDate] = useState(new Date())
  const [quart, setQuart] = useState([])
  const [selectQuart, setSelectQuart] = useState("")
  const [type, setType] = useState([])
  const [selectType, setSelectType] = useState([])
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [matiere, setMatiere] = useState([])
  const [selectMatiere, setSelectMatiere] = useState("")
  const [jourId, setJourId] = useState("")
  const [enseignant, setEnseignant] = useState([])
  const [selectEnseignant, setSelectEnseignant] = useState("")
  const [salle, setSalle] = useState([])
  const [selectSalle, setSelectSalle] = useState("")
  const [semestre, setSemestre] = useState([
    { value: 1, label: "Semestre 1" },
    { value: 2, label: "Semestre 2" },
  ])
  const [selectSemestre, setSelectSemestre] = useState("")
  var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
  )
  var annee_id = userAuthScolarite.user.annee_id
  const [tousEtudiant, setTousEtudiant] = useState(1)
  const [selectDisabled, setSelectDisabled] = useState(true);
  const [etudiant, setEtudiant] = useState([]);
  const [selectEtudiant, setSelectEtudiant] = useState("");
  const [selectMulti, setSelectMulti] = useState(false);
  const [nbrHeureSeance, setNbrHeureSeance] = useState([
    { value: 2, label: "1h" },
    { value: 3, label: "1h:30" },
    { value: 4, label: "2h" },
    { value: 5, label: "2h:30" },
    { value: 6, label: "3h" },
  ])
  const [selectNbrHeureSeance, setSelectNbrHeureSeance] = useState("");
  useEffect(async () => {
    // convert date début
    let date = new Date()
    let month = "" + (date.getMonth() + 1)
    let day = "" + date.getDate()
    let year = date.getFullYear()
    if (month.length < 2) month = "0" + month
    if (day.length < 2) day = "0" + day
    let convertDate = [year, month, day].join("-")
    const resDate = await API.post("quart/get_date", {
      date: convertDate,
    }).then(resDate => {
      setJourId(resDate.data.Date)
    })
    const res = await API.post("enseignant/select",{annee_id}).then(res => {
      setEnseignant(res.data.select_enseignant)
    })
    const resQ = await API.get("quart/select_debut").then(resQ => {
      setQuart(resQ.data.Quart)
    })
  }, [])

  const isWeekday = date => {
    const day = getDay(date)
    return day !== 0
  }

  const getTypeMatiere = async e => {
    setSelectSemestre(e)
    setDate(new Date())
    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    setTousEtudiant(1)
    setSelectEtudiant("")
    setEtudiant([])
    setSelectDisabled(true);
    const res = await API.post("emploi/get_type_matiere", {
      enseignant_id: selectEnseignant.value,
      semestre_id: e.value,annee_id
    }).then(res => {
      setType(res.data.emploi)
    })
  }

  const getQuart = e => {
    setSelectQuart(e)
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    setTousEtudiant(1)
    setSelectDisabled(true);
    setEtudiant([])
    setSelectEtudiant("")
  }
  const getEnseignant = e => {
    setSelectEnseignant(e)
    setSelectSemestre("")
    setDate(new Date())
    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    setTousEtudiant(1)
    setSelectEtudiant("")
    setEtudiant([])
    setSelectDisabled(true);
  }

  const getDay1 = async e => {
    setDate(e)
    setSelectQuart("")
    setSelectType("")
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    // convert date début
    let date = e
    let month = "" + (date.getMonth() + 1)
    let day = "" + date.getDate()
    let year = date.getFullYear()
    if (month.length < 2) month = "0" + month
    if (day.length < 2) day = "0" + day
    let convertDate = [year, month, day].join("-")
    const res = await API.post("quart/get_date", {
      date: convertDate,
    }).then(res => {
      setJourId(res.data.Date)
    })
  }

  const getMatiere = async e => {
    setSelectType(e)
    setSelectMatiere("")
    setSelectGroupe("")
    setSelectSalle("")
    setTousEtudiant(1)
    setSelectEtudiant("")
    setEtudiant([])
    setSelectDisabled(true);
    const res = await API.post("emploi/get_matiere", {
      type: e.value,
      enseignant_id: selectEnseignant.value,
      semestre_id: selectSemestre.value,
      annee_id
    }).then(res => {
      setMatiere(res.data.matieres)
    })
  }

  const getGroupe = async e => {
    setSelectMatiere(e)
    setSelectGroupe("")
    setSelectSalle("")
    setTousEtudiant(1)
    setSelectEtudiant("")
    setEtudiant([])
    setSelectDisabled(true);
    const resType = await API.post("seance/get_type_enseignement", {
      matiere_id: e.value,
    }).then(resType => {
      if(resType.data.type == 2){
        setTousEtudiant(2)
        setSelectDisabled(false);
        setSelectMulti(false)
      }else if(resType.data.type == 1){
        setTousEtudiant(1)
        setSelectDisabled(true);
      }else if (resType.data.type == 3){
        setTousEtudiant(3)
        setSelectDisabled(false);
        setSelectMulti(true)
      }

    })
    const resG = await API.post("emploi/get_group", {
      quart_id: selectQuart.value,
      jour_id: jourId,
      quan: 0,
      matiere_id: e.value,
      type: selectType.value,
      semestre_id: selectSemestre.value,
      enseignant_id: selectEnseignant.value,
      annee_id
    }).then(resG => {
      setGroupe(resG.data.groups)
    })
  }

  const getSalle = async e => {
    setSelectGroupe(e)
    setSelectSalle("")
    setSelectEtudiant("")
    setEtudiant([])
    const resS = await API.post("emploi/get_salle", {
      quart_id: selectQuart.value,
      jour_id: jourId,
      semestre_id: selectSemestre.value,
      quan: 0,
      annee_id
    }).then(resS => {
      setSalle(resS.data.salles)
    })
    API.post("seance/list_etudiant_by_group_type_id_avis_rattrapage", {
      matiere_id: selectMatiere.value,
      group_id: e,
      type: selectType.value,
      quart_id: selectQuart.value,
      jour_id: jourId,
    }).then(resS => {
      setEtudiant(resS.data.Etudiant)
    })
  }

  const save = async () => {
    //
    if (selectEnseignant == "") {
      toast.error("⛔ Enseignant obligatoire !", {
        containerId: "A",
      })
    } else if (selectSemestre == "") {
      toast.error("⛔ Semestre obligatoire !", {
        containerId: "A",
      })
    }else if (date == null) {
      toast.error("⛔ Date obligatoire !", {
        containerId: "A",
      })
    }else if (selectQuart == "") {
      toast.error("⛔ Début de séance obligatoire !", {
        containerId: "A",
      })
    }else if (selectNbrHeureSeance == "") {
      toast.error("⛔ Nbr heure seance obligatoire !", {
        containerId: "A",
      })
    } else if (selectType == "") {
      toast.error("⛔ Type obligatoire !", {
        containerId: "A",
      })
    } else if (selectMatiere == "") {
      toast.error("⛔ Matiere obligatoire !", {
        containerId: "A",
      })
    }  else if (selectSalle == "") {
      toast.error("⛔ Matiere obligatoire !", {
        containerId: "A",
      })
    } else if (selectGroupe != "") {
      // convert date début
      let dateRatt = date
      let month = "" + (dateRatt.getMonth() + 1)
      let day = "" + dateRatt.getDate()
      let year = dateRatt.getFullYear()
      if (month.length < 2) month = "0" + month
      if (day.length < 2) day = "0" + day
      let convertDate = [year, month, day].join("-")
      //
      if(selectEtudiant != ""){
        if(tousEtudiant == 2){
          var etudiant_id=selectEtudiant.value
        }else{
          var etudiant_id=selectEtudiant
        }
      }else{
        var etudiant_id=null
      }
      const res = await API.post("avis/rattrapage/store_rattrapage", {
        date: convertDate,
        enseignant_id: selectEnseignant.value,
        jour_id: jourId,
        quart_id: selectQuart.value,
        matiere_id: selectMatiere.value,
        group_id: selectGroupe,
        salle_id: selectSalle.value,
        type: selectType.value,
        semestre_id: selectSemestre.value,
        quan: 0,
        annee_id,
        type_seance:tousEtudiant,
        etudiant_id:etudiant_id,
        nb_heure_seance:selectNbrHeureSeance.value
      })
        .then(res => {
          const resA = API.post("avis/rattrapage/store", {
            date: convertDate,
            enseignant_id: selectEnseignant.value,
            jour_id: jourId,
            quart_id: selectQuart.value,
            matiere_id: selectMatiere.value,
            group_id: selectGroupe,
            salle_id: selectSalle.value,
            type: selectType.value,
            semestre_id: selectSemestre.value,
            quan: 0,
            annee_id,
            type_seance:tousEtudiant,
            etudiant_id:etudiant_id,
            nb_heure_seance:selectNbrHeureSeance.value
          }).then(resA => {
            const resN = API.post("avis/rattrapage/notif_success", {
              id: res.data.AvisEnseignant,
            })
            const resE = API.post("avis/rattrapage/notif_success_etudiant", {
              id: res.data.AvisEnseignant,
            })
            props.setSection(1)
          })
        })
        .catch(() => {
          toast.error("Problème lors de l'insertion !", {
            containerId: "A",
          })
        })
    } else {
      toast.error("⛔ Groupe obligatoire !", {
        containerId: "A",
      })
    }
  }
  const TousEtudiant = async () => {
    setTousEtudiant(1)
    setSelectGroupe("")
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    setSelectGroupe("")
    setSelectDisabled(true);
    const resG = await API.post("emploi/get_group", {
      semestre_id: semestre_id,
      quart_id: quartId,
      jour_id: jourId,
      quan: etatQuanzaine,
      matiere_id: selectMatiere.value,
      type: selectType.value,
      enseignant_id: enseignantId,
      annee_id:annee_id
    }).then(resG => {
      setGroupe(resG.data.groups)
    })
  }
  const filterEtudiant = async () => {
    setSelectGroupe("")
    setTousEtudiant(2)
    setSelectDisabled(false);

  }
  return (
    <React.Fragment>
      <Row>
        <Form>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Enseignant")}
                </Label>
                <Select
                  options={enseignant}
                  isSearchable={true}
                  value={selectEnseignant}
                  onChange={e => getEnseignant(e)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Semestre")}
                </Label>
                <Select
                  options={semestre}
                  isSearchable={true}
                  value={selectSemestre}
                  onChange={e => getTypeMatiere(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Date")}
                  <span style={{ color: "red", paddingLeft: "5px" }}>*</span>
                </Label>
                <DatePicker
                  selected={date}
                  filterDate={isWeekday}
                  className="form-control ddate"
                  dateFormat="dd/MM/yyyy"
                  onChange={e => getDay1(e)}
                />
              </div>
            </Col>
            <Col lg="3">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">
                  {props.t("Début de séance")}
                </Label>
                <Select
                  options={quart}
                  isSearchable={true}
                  value={selectQuart}
                  onChange={e => getQuart(e)}
                />
              </div>
            </Col>
            <Col lg="3">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Nbr heure seance</Label>
                <Select
                    options={nbrHeureSeance}
                    isSearchable={true}
                    value={selectNbrHeureSeance}
                    onChange={e => setSelectNbrHeureSeance(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Type</Label>
                <Select
                  options={type}
                  isSearchable={true}
                  value={selectType}
                  onChange={e => getMatiere(e)}
                />
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Matiere</Label>
                <Select
                  options={matiere}
                  isSearchable={true}
                  value={selectMatiere}
                  onChange={e => getGroupe(e)}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <div className="mb-3">
                <Label className="d-block mb-3">Choix des groupes :</Label>
                <div className="form-check form-check-inline">
                  <Input
                      type="radio"
                      id="customRadioInline1"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={tousEtudiant === 1}
                      disabled={true}
                      onChange={e => TousEtudiant(1)}
                  />
                  <Label
                      className="form-check-label"
                      htmlFor="customRadioInline1"
                  >
                    Groupe
                  </Label>
                </div>
                &nbsp;
                <div className="form-check form-check-inline">
                  <Input
                      type="radio"
                      id="customRadioInline2"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={tousEtudiant === 2}
                      disabled={true}
                      onChange={e => filterEtudiant(2)}
                  />
                  <Label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                  >
                    Seule etudiant
                  </Label>
                </div>
                <div className="form-check form-check-inline">
                  <Input
                      type="radio"
                      id="customRadioInline2"
                      name="customRadioInline1"
                      className="form-check-input"
                      checked={tousEtudiant === 3}
                      disabled={true}

                  />
                  <Label
                      className="form-check-label"
                      htmlFor="customRadioInline2"
                  >
                    Groupe etudiant
                  </Label>
                </div>
              </div>
            </Col>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Groupe</Label>
                <Select
                    options={groupe}
                    isSearchable={true}
                    value={selectGroupe}
                    onChange={e => getSalle(e)}
                    isMulti={true}
                />
              </div>
            </Col>

          </Row>
          <Row>
            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Salle</Label>
                <Select
                    options={salle}
                    isSearchable={true}
                    value={selectSalle}
                    onChange={e => setSelectSalle(e)}
                />
              </div>
            </Col>

            <Col lg="6">
              <div className="mb-3">
                <Label for="basicpill-firstname-input1">Etudiant</Label>
                <Select
                    options={etudiant}
                    isSearchable={true}
                    value={selectEtudiant}
                    onChange={e => setSelectEtudiant(e)}
                    isDisabled={selectDisabled}
                    isMulti={selectMulti}
                />
              </div>
            </Col>
          </Row>
        </Form>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {" "}
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
              className="text-center mt-4"
            >
              <Button
                type="button"
                color="warning"
                className="btn btn-warning  mb-2 me-2"
                onClick={props.back}
              >
                {props.t("Annuler")}
              </Button>
            </div>
          </Col>
          <Col lg="6">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
              }}
              className="text-center mt-4"
            >
              <button type="button" className="btn btn-primary " onClick={save}>
                {props.t("Confirmer")}
              </button>
            </div>
          </Col>
        </div>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(AddRattrapage))
AddRattrapage.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
